import { supabase } from './supabase';

const ARQUIVOS_BUCKET = 'caso-arquivos';

export async function carregarDadosCasoPortal(token) {
  const { data, error } = await supabase.rpc('caso_cliente_get_dados', { p_token: token });
  if (error) throw new Error(error.message);
  if (data?.erro) throw new Error(data.erro);
  return data;
}

export function linkCasoPortal(token) {
  return `${window.location.origin}/meu-caso/${token}`;
}

// Path sempre aleatório (nunca o nome original do arquivo) — quem baixa
// precisa de uma signed URL de qualquer forma, o path em si não expõe nada.
export async function subirArquivoCaso(casoId, categoria, nome, file) {
  const ext = (file.name.split('.').pop() || 'pdf').toLowerCase();
  const path = `${casoId}/${crypto.randomUUID()}.${ext}`;
  const { error } = await supabase.storage.from(ARQUIVOS_BUCKET).upload(path, file, { upsert: false });
  if (error) throw new Error(error.message);
  const { data, error: errIns } = await supabase.from('caso_arquivos')
    .insert([{ caso_id: casoId, categoria, nome, storage_path: path }])
    .select().single();
  if (errIns) throw new Error(errIns.message);
  return data;
}

export async function removerArquivoCaso(arquivo) {
  await supabase.storage.from(ARQUIVOS_BUCKET).remove([arquivo.storage_path]);
  const { error } = await supabase.from('caso_arquivos').delete().eq('id', arquivo.id);
  if (error) throw new Error(error.message);
}

export async function urlAssinadaArquivoCaso(storagePath, expiraEmSegundos = 3600) {
  const { data, error } = await supabase.storage.from(ARQUIVOS_BUCKET).createSignedUrl(storagePath, expiraEmSegundos);
  if (error) throw new Error(error.message);
  return data.signedUrl;
}
